import React, { Component } from "react";
import { Row } from "simple-flexbox";
import DetailNameComponent from "../../components/detail/DetailNameComponent";

import { withRouter } from "react-router-dom";
import FormContainer from "../../components/container/FormContainer";
import EditButtonComponent from "../../components/form/EditButtonComponent";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import {
    renderDatepicker, renderFile,
    renderInput, RenderInputCurrency,
    renderSelect,
} from "../../components/form/FormComponent";
import { StyleSheet, css } from "aphrodite";
import { listCity } from "../../actions/master-data/city_action";
import { provinceList } from "../../actions/master-data/province_action";
import DetailSubTitleComponent from "../../components/detail/DetailSubTitleComponent";
import {Col, Row as BootstrapRow} from "react-bootstrap";
import ContainerComponent from "../../components/container/ContainerComponent";
import SingleContainerComponent from "../../components/container/SingleContainerComponent";
import MUIRichTextEditor from "mui-rte";
import {ContentState, convertToRaw} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import {
    deleteJobSpotError,
    deleteJobSpotPending,
    getJobSpot,
    getJobSpotError,
    getJobSpotPending
} from "../../reducers/jobspot/jobspot";
import {editJobSpot, jobSpotList} from "../../actions/jobspot/jobspot_action";
import {getCityList} from "../../reducers/master-data/city_reducer";
import {getProvinceList} from "../../reducers/master-data/province_reducer";
import DetailContentLihatBerkas from "../../components/detail/DetailContentLihatBerkas";
import ModalDetailPhoto from "../profile-admin/Modal_document";
import {toRupiahs} from "../../helpers/formatter";
import moment from "moment/moment";
import {history} from "../../helpers/history";
import {saveRichText} from "../../helpers/utils";
import {Save} from "@material-ui/icons";


class JobSpotDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: false,
            isEditFile: false,
            selectedItem: "pengantar",
            modalDetailPhotoShow: false,
            typeJobOptions: [
                {label: "Spesialis", value: "Spesialis"},
                {label: "Subspesialis", value: "Subspesialis"},
            ],
            contractOptions: [
                {label: "Fulltime", value: "Fulltime"},
                {label: "Parttime", value: "Parttime"},
            ],
            data: "",
            html: "",
            desc_error: false,
        };
        this.tableRef = React.createRef();

        this.handleTriggerFormEdit = this.handleTriggerFormEdit.bind(this);
        this.handleTriggerEditFile = this.handleTriggerEditFile.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleErrors = this.handleErrors.bind(this);
    }

    handleOpenPhoto(imgUrl, modal_title) {
        this.setState({ imgUrl: imgUrl })
        this.setState({ modal_title: modal_title })
        this.setState({ modalDetailPhotoShow: true })
    }

    handleSave(data) {
        let result = saveRichText(data)
        this.setState({
            html: result,
        })
    };

    handleErrors(){
        const { html } = this.state;
        this.setState({
            desc_error: html === "<p></p>\n",
        })
    }

    componentDidMount() {
        const { jobSpotList, match, provinceList, listCity } = this.props;

        jobSpotList({ id: match.params.id, published_only: "false" });
        provinceList({length: 999});
        listCity({length: 999})
    }

    handleTriggerFormEdit() {
        this.setState({ isEdit: !this.state.isEdit });
        this.setState({ isEditFile: false });
        this.props.reset();
    }

    handleTriggerEditFile() {
        const { instance_logo } = this.props;
        if (instance_logo) {
            this.props.change("instance_logo", null);
        }
    }

    async handleSubmit (values) {
        await this.handleErrors();

        const { editJobSpot } = this.props;
        const { html, desc_error } = this.state;
        let registration_start_date = values?.registration_start_date;
        let registration_end_date = values?.registration_end_date;
        let salary_start =  values?.salary_start_range === "Rp 0" ? null : values?.salary_start_range;
        let salary_end =  values?.salary_end_range === "Rp 0" ? null : values?.salary_end_range;

        let param = {
            ...values,
            instance_logo: values?.instance_logo || "",
            contract: values?.contract?.value || "",
            type_job: values?.type_job?.value || "",
            city: values.city?.value || "",
            province: values.province?.value || "",
            salary_start_range: !salary_start ? null : values?.salary_start_range?.replace(/[^0-9]/g, ''),
            salary_end_range: !salary_end ? null : values?.salary_end_range?.replace(/[^0-9]/g, ''),
            registration_start_date: registration_start_date
                ? moment(registration_start_date)
                    .format("DD-MM-YYYY")
                : "",
            registration_end_date: registration_end_date
                ? moment(registration_end_date)
                    .format("DD-MM-YYYY")
                : "",
            published_start_date: moment(values?.published_start_date).format("DD-MM-YYYY"),
            published_end_date: moment(values?.published_end_date).format("DD-MM-YYYY"),
            description: html || values?.description,
        };


        const callback = () => {
            history.push("/jobspot");
        };

        !desc_error && editJobSpot(param, callback);
    }

    render() {
        const {
            listCity_data,
            listProvince_data,
            instance_logo,
            handleSubmit,
            initialValues,
            change
        } = this.props;

        const {
            isEdit,
            contractOptions,
            typeJobOptions,
            desc_error,
            html
        } = this.state;

        let cityOptions = [],
            provinceOptions = [];

        const handleCityChange = (state) => {
            listCity({length: !state ? 0 : 10, province_id: state?.value || ""});
        }

        if(listCity_data && listCity_data.data.length !== 0){
            cityOptions = listCity_data.data.map((item) => ({
                label: item.name,
                value: item.city_id,
            }));
        }

        if (listProvince_data && listProvince_data.length !== 0) {
            provinceOptions = listProvince_data.map((item) => ({
                label: item.name,
                value: item.province_id,
            }));
        }

        let currentYear = new Date().getFullYear();
        let yearOptions = [];
        for (let i = currentYear; i >= 1900; i--) {
            yearOptions = [...yearOptions, { label: i, value: i }];
        }
        let introduction = html || initialValues?.description || '';
        const blocksFromHtml = htmlToDraft(introduction);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = JSON.stringify(
            convertToRaw(ContentState.createFromBlockArray(contentBlocks, entityMap))
        );

        return (
            <ContainerComponent>
                <ModalDetailPhoto
                    show={this.state.modalDetailPhotoShow}
                    onHide={() => this.setState({ modalDetailPhotoShow: false })}
                    imgUrl={this.state.imgUrl}
                    modal_title={this.state.modal_title}
                    folder="job_spot"
                />
                <SingleContainerComponent>
                    <form
                        onSubmit={handleSubmit(this.handleSubmit)}
                        style={{ width: "100%" }}
                    >
                        <Row
                            vertical="center"
                            horizontal="space-between"
                            style={{ width: "100%", marginBottom: 20 }}
                        >
                            <DetailNameComponent name="Detail" />
                            <EditButtonComponent
                                isEdit={isEdit}
                                triggerIsEdit={this.handleTriggerFormEdit}
                            />
                        </Row>
                        <DetailSubTitleComponent title="Informasi Pekerjaan"/>
                        <BootstrapRow lg={isEdit ? 2 : 1}>
                            <Col md={12}>
                                <FormContainer mandatory label="Nama Pekerjaan">
                                    <Field
                                        isDetail={!isEdit}
                                        name="name"
                                        placeholder="Masukkan Nama Pekerja"
                                        component={renderInput}
                                    />
                                </FormContainer>
                                <FormContainer label="Jenis">
                                    <Field
                                        isDetail={!isEdit}
                                        name="type_job"
                                        options={typeJobOptions}
                                        placeholder="Pilih Jenis"
                                        component={renderSelect}
                                    />
                                </FormContainer>
                            </Col>
                            <Col md={12}>
                                <FormContainer mandatory label="Kontrak Kerja">
                                    <Field
                                        isDetail={!isEdit}
                                        name="contract"
                                        placeholder="Pilih Kontrak Kerja"
                                        options={contractOptions}
                                        component={renderSelect}
                                    />
                                </FormContainer>
                            </Col>
                        </BootstrapRow>
                        <DetailSubTitleComponent title="Informasi Perusahaan"/>
                        <BootstrapRow lg={isEdit ? 2 : 1}>
                            <Col md={12}>
                            <FormContainer mandatory label="Instansi">
                                <Field
                                    isDetail={!isEdit}
                                    name="instance"
                                    placeholder="Masukkan instansi"
                                    component={renderInput}
                                />
                            </FormContainer>
                            </Col>
                            <Col md={12}>
                                <FormContainer label="Logo Instansi">
                                    {isEdit ? (
                                        <div>
                                            <Field
                                                isDetail={!isEdit}
                                                name="instance_logo"
                                                type="file"
                                                fileType="image"
                                                title="Upload"
                                                filename={instance_logo}
                                                filePath="job_spot"
                                                triggerEditFile={this.handleTriggerEditFile}
                                                isEditFile={isEdit}
                                                component={renderFile}
                                            />
                                            <span style={{float: "right"}}>(Max File 1 MB)</span>
                                        </div>
                                    ) : !instance_logo
                                            ? (<span>Tidak ada berkas</span>)
                                            :  (<DetailContentLihatBerkas onClick={() => this.handleOpenPhoto(instance_logo, "Logo Instansi")} />)}
                            </FormContainer>
                            </Col>
                        </BootstrapRow>

                        {/*Divider*/}
                        <DetailSubTitleComponent title="Lokasi Pekerjaan"/>
                        <BootstrapRow lg={isEdit ? 2 : 1}>
                            <Col md={12}>
                                <FormContainer label="Jalan">
                                    <Field
                                        isDetail={!isEdit}
                                        name="address"
                                        placeholder="Masukkan jalan"
                                        component={renderInput}
                                    />
                                </FormContainer>
                                <FormContainer mandatory label="Provinsi">
                                    <Field
                                        isDetail={!isEdit}
                                        options={provinceOptions}
                                        name="province"
                                        isAsync
                                        type="province"
                                        asyncUrl="master_data/data_reference/find_province"
                                        placeholder="Pilih provinsi"
                                        onChange={(state) => {
                                            if(!state){
                                                change("city", null);
                                                handleCityChange(null);
                                            }else{
                                                handleCityChange(state)
                                            }
                                        }}
                                        component={renderSelect}
                                    />
                                </FormContainer>
                            </Col>
                            <Col md={12}>
                                <FormContainer mandatory label="Kabupaten/Kota">
                                    <Field
                                        isDetail={!isEdit}
                                        options={cityOptions}
                                        name="city"
                                        disabled={cityOptions.length < 1}
                                        onFocus={() => {
                                            cityOptions.length < 1 &&
                                            handleCityChange(initialValues?.province);
                                        }}
                                        isAsync
                                        type="city"
                                        customParams={{
                                            province_id: initialValues?.province,
                                            length: 10
                                        }}
                                        asyncUrl="master_data/data_reference/find_city"
                                        placeholder="Pilih Kabupaten/Kota"
                                        component={renderSelect}
                                    />
                                </FormContainer>
                                <FormContainer label="Kecamatan">
                                    <Field
                                        isDetail={!isEdit}
                                        name="district"
                                        placeholder="Pilih kecamatan"
                                        component={renderInput}
                                    />
                                </FormContainer>
                            </Col>
                        </BootstrapRow>

                        {/*Divider*/}
                        <DetailSubTitleComponent title="Detail Lowongan "/>
                        <BootstrapRow lg={isEdit ? 2 : 1}>
                            <Col md={12}>
                                <FormContainer label="Tanggal Pendaftaran">
                                    <div className={css(styles.flexBox)}>
                                        <div>
                                            <Field
                                                isDetail={!isEdit}
                                                name="registration_start_date"
                                                component={renderDatepicker}
                                                isNotAutofill
                                                customFormat="DD MMMM YYYY"
                                            />
                                        </div>
                                        <div> - </div>
                                        <div>
                                            <Field
                                                isDetail={!isEdit}
                                                name="registration_end_date"
                                                component={renderDatepicker}
                                                isNotAutofill
                                                customFormat="DD MMMM YYYY"
                                            />
                                        </div>
                                    </div>
                                </FormContainer>
                                <FormContainer mandatory label="Durasi Posting">
                                    <div className={css(styles.flexBox)}>
                                        <div>
                                            <Field
                                                isDetail={!isEdit}
                                                name="published_start_date"
                                                component={renderDatepicker}
                                                isNotAutofill
                                                customFormat="DD MMMM YYYY"
                                            />
                                        </div>
                                        <div> - </div>
                                        <div>
                                            <Field
                                                isDetail={!isEdit}
                                                name="published_end_date"
                                                component={renderDatepicker}
                                                isNotAutofill
                                                customFormat="DD MMMM YYYY"
                                            />
                                        </div>
                                    </div>
                                </FormContainer>
                            </Col>
                            <Col md={12}>
                                <FormContainer label="Gaji/Bulan">
                                    <div className={css(styles.flexBox)}>
                                        <div>
                                            <Field
                                                isDetail={!isEdit}
                                                name="salary_start_range"
                                                component={RenderInputCurrency}
                                            />
                                        </div>
                                        <div> - </div>
                                        <div>
                                            <Field
                                                isDetail={!isEdit}
                                                name="salary_end_range"
                                                component={RenderInputCurrency}
                                            />
                                        </div>
                                    </div>
                                </FormContainer>
                            </Col>
                        </BootstrapRow>

                        {/*Divider*/}
                        <DetailSubTitleComponent
                            isEdit={isEdit}
                            title="Deskripsi Lowongan"
                            mandatory
                            message={(
                                <>
                                    Catatan: Tekan ikon <Save/> di text editor (box deskripsi)
                                    sebelum menyimpan hasil perubahan.
                                </>
                            )}
                            error={desc_error}
                        />
                        {isEdit && <MUIRichTextEditor
                            onSave={this.handleSave}
                            ref={this.tableRef}
                            controls={[
                                "title",
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "undo",
                                "redo",
                                "link",
                                "clear",
                                "link",
                                "save"
                            ]}
                            autoFocus={false}
                            defaultValue={contentState}
                        />}
                        {!isEdit &&
                            <FormContainer label="Deskripsi">
                                <Field
                                isDetail={!isEdit}
                                name="description"
                                component={renderInput}
                                richText
                                />
                            </FormContainer>
                        }
                    </form>
                </SingleContainerComponent>
            </ContainerComponent>
        );
    }
}

const styles = StyleSheet.create({
    flexBox:{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        justifyContent: "flex-start",
    },
    dot: {
        height: 8,
        width: 8,
        borderRadius: 4,
        backgroundColor: "black",
        margin: "0px 10px",
    },
    icon: {
        position: "absolute",
        top: 0,
        height: 20,
        color: "#495057",
        width: 20,
    },
});

function validate(values) {
    const {
        name,
        contract,
        instance,
        province,
        city,
        published_start_date,
        published_end_date,
    } = values;
    const errors = {};
    if (!name) {
        errors.name = "Nama Lowongan wajib diisi";
    }
    if (!contract) {
        errors.contract = "Kontrak Kerja wajib diisi";
    }
    if (!instance) {
        errors.instance = "Instansi wajib diisi";
    }
    if (!published_start_date) {
        errors.published_start_date = "Durasi Posting wajib diisi";
    }
    if (!published_end_date) {
        errors.published_end_date = "Durasi Posting wajib diisi";
    }
    if (!province) {
        errors.province = "Provinsi wajib diisi";
    }
    if (!city && !province) {
        errors.city = "Pilih provinsi terlebih dahulu";
    }
    if (!city && province) {
        errors.city = "Kabupaten/Kota wajib diisi";
    }

    return errors;
}

JobSpotDetail = reduxForm({
    // a unique name for the form
    form: "JobSpotDetail",
    validate: validate,
    // keepDirtyOnReinitialize: true,
    shouldError: () => true,
    enableReinitialize: true,
})(JobSpotDetail);

function mapStateToProps(state) {

    const { jobSpot, listCity, provinceList } = state;
    const detailJobSpot = getJobSpot(jobSpot);
    let cities = getCityList(listCity)
    let provinces = getProvinceList(provinceList)
    const data = detailJobSpot?.data[0];
    const getCity = cities && cities?.data.find((item) => item.city_id === data?.city);
    const getProvince = provinces && provinces.find((item) => item.province_id === data?.province);
    let type_job;
    if(data?.type_job){
        type_job = {
            label: data?.type_job,
            value: data?.type_job,
        }
    }

    let initialValues = {
        ...data,
        ...type_job,
        province: {
            label: getProvince?.name,
            value: getProvince?.province_id,
        },
        city: {
            label: getCity?.name,
            value: getCity?.city_id,
        },
        contract: {
            label: data?.contract,
            value: data?.contract,
        },
        salary_start_range: !data?.salary_start_range ? null : toRupiahs(data?.salary_start_range),
        salary_end_range: !data?.salary_end_range ? null : toRupiahs(data?.salary_end_range),
    };


    return {
        jobSpotList_pending: getJobSpotPending(jobSpot),
        jobSpotList_data: getJobSpot(jobSpot),
        jobSpotList_error: getJobSpotError(jobSpot),
        jobSpotDelete_pending: deleteJobSpotPending(jobSpot),
        jobSpotDelete_error: deleteJobSpotError(jobSpot),
        listProvince_data: provinces,
        listCity_data: cities,
        initialValues,
        instance_logo: data?.instance_logo,
    };
}

export default connect(mapStateToProps, {
    jobSpotList,
    listCity,
    provinceList,
    editJobSpot,
})(withRouter(JobSpotDetail));
